<!-- 获取账号下所有授权停车场的编码接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {
                "data": {
                    "parkInfoList": [
                        {
                            "parkCode": "2KM9FRZU",
                            "parkName": "111"
                        },
                        {
                            "parkCode": "2KM8BWT4",
                            "parkName": "170停车场"
                        }
                    ]
                },
                "message": "业务成功", "resultCode": 0, "status": 1
                },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取该账号下的所有授权停车场编码",
                t_url: this.commonUrls.test+"getAuthParkOfMobilePatrolList",
                p_url: this.commonUrls.prod+"getAuthParkOfMobilePatrolList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkInfoList', info2: '是', info3: 'JSONArray', info4: '停车场列表，parkName：停车场名称,parkCode：停车场编码' }
                        ]
                },{
                    titleName: 'parkInfoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'gpsx', info2: '是', info3: 'Double', info4: 'x坐标' },
                        { info1: 'gpsy', info2: '是', info3: 'Double', info4: 'y坐标' },
                        { info1: 'isV3Park', info2: '否', info3: 'boolean', info4: '是否智汇云车场, 3.0车场才会返回' },
                        { info1: 'isIllegalPush', info2: '否', info3: 'boolean', info4: '是否支持违规推送' },
                        { info1: 'isIllegalPushExpire', info2: '否', info3: 'boolean', info4: '违规推送过期时间' },
                        { info1: 'isIllegalPushWechat', info2: '否', info3: 'boolean', info4: '是否支持违规推送-公众号推送' },
                        { info1: 'isIllegalPushMessage', info2: '否', info3: 'boolean', info4: '是否支持违规推送-短信推送' },
                        { info1: 'isEmergencyPush', info2: '否', info3: 'boolean', info4: '是否支持应急推送' },
                        { info1: 'isEmergencyPushExpire', info2: '否', info3: 'String', info4: '应急推送过期时间' }

                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/carSearch/getAuthParkOfMobilePatrolList.vue